import { PasswordField } from '@components/Fields/PasswordField';
import { IForm } from '@hooks/useForm';
import { Grid } from '@material-ui/core';
import { IPasswordChangeRequest } from '@services/AuthService';
import React from 'react';

export type AlterarSenhaFormProps = {
    form: IForm<IPasswordChangeRequest>
}

export function AlterarSenhaForm ({ form }: AlterarSenhaFormProps) {
    return (
        <Grid container spacing={1}>
            <Grid item>
                <PasswordField 
                    field={form.fields.currentPass}
                    label="Senha Atual"
                    required
                    fullWidth
                />
            </Grid>

            <Grid item>
                <PasswordField 
                    field={form.fields.newPass}
                    label="Nova Senha"
                    required
                />
            </Grid>

            <Grid item>
                <PasswordField 
                    field={form.fields.confirmPass}
                    label="Confirmar Senha"
                    required
                />
            </Grid>
        </Grid>
    )
}